import { forwardRef } from "react";
const SvgWeight = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<circle cx={8} cy={3} r={2} stroke="currentColor" strokeWidth={2} /><path d="M3.57804 7.08907C3.76164 6.44455 4.35049 6 5.02066 6H10.9793C11.6495 6 12.2384 6.44455 12.422 7.08907L14.131 13.0891C14.4039 14.047 13.6845 15 12.6884 15H3.31157C2.3155 15 1.59608 14.047 1.86895 13.0891L3.57804 7.08907Z" stroke="currentColor" strokeWidth={2} /></svg>;
const ForwardRef = forwardRef(SvgWeight);
export default ForwardRef;